import secureLocalStorage from "react-secure-storage";
import React, { PureComponent } from "react";
import "../../Styles/RiskViews.scss";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import ValidateNumberCell from "./ValidateNumberCell";
import { process } from "@progress/kendo-data-query";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
export default class ValidateTasks extends PureComponent {
  constructor(props) {
    super(props);
    this.state = this.createAppState({
      ...this.state,
      sort: [{ field: "code", dir: "asc" }],
      take: 20,
      skip: 0,
      validateData: [],
    });
  }
  componentDidMount() {
    this.GetTemporaryTaskListForUploader();
  }

  GetTemporaryTaskListForUploader = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      const requestParams = {
        workstreamId: this.props.workstreamId,
      };
      let response = await Api.GetTemporaryTaskListForUploader(requestParams);
      if (response.status === 200) {
        let aggregateCellsCount=0;
        response.taskRegisterResponses.map((riskReg) => {
          if(riskReg.nonUpdatedColumnsFromExcel&&riskReg.nonUpdatedColumnsFromExcel.length>0){
            aggregateCellsCount=aggregateCellsCount + riskReg.nonUpdatedColumnsFromExcel.length;
          }
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); 
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); 
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); 
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate);
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }

          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        this.props.handleValidateDataCount({
          newTaskCount: response.newTaskCount,
          modifiedTaskCount: response.modifiedTaskCount,
          aggregateCellsCount:aggregateCellsCount,
          closedTaskCount:response.closedTaskCount
        });
        await this.createDynamicDropdowns(response.taskRegisterResponses);
        this.setState({
          ...this.state,
          validateData: response.taskRegisterResponses,
          validateDataTemp: response.taskRegisterResponses,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, loader: false });
        this.props.handleValidateDataCount({
          newTaskCount: response.newTaskCount,
          modifiedTaskCount: response.modifiedTaskCount,
          aggregateCellsCount:0,
          closedTaskCount:0
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  createDynamicDropdowns = async (products) => {
   try {
         let dropdownColumn = [];
         products.map((res, i) => {
           res.customFields &&
             res.customFields.map((item, j) => {
               if (dropdownColumn.length > 0) {
                 if (
                   !dropdownColumn.find((cf) => cf.fieldName === item.fieldName)
                 ) {
                   dropdownColumn.push({
                     fieldName: item.fieldName,
                     data: this.getCustomFieldMasterData(item.fieldName),
                     inputType: this.getInputType(item.fieldName),
                   });
                 }
               } else {
                 dropdownColumn.push({
                   fieldName: item.fieldName,
                   data: this.getCustomFieldMasterData(item.fieldName),
                   inputType: this.getInputType(item.fieldName),
                 });
               }
             });
         });
   
         if (dropdownColumn.length > 0) {
           products.map((res) => {
             dropdownColumn.map((col) => {
               let temp = res.customFields.find(
                 (item) => item.fieldName === col.fieldName
               );
               if (temp) {
                 if (temp.inputType === "Multi Drop Down") {
                   let val = temp.selectedCustomFieldNames
                     ? temp.selectedCustomFieldNames.toString()
                     : "";
                   // let hashArr = this.stringToHashForCF(val, col.data);
                   res[col.fieldName] = val;
                 } else if (temp.inputType === "Single Drop Down") {
                   let val = temp.selectedCustomFieldNames
                     ? temp.selectedCustomFieldNames.toString()
                     : "";
                   res[col.fieldName] = val;
                 } else if (temp.inputType === "Free Text") {
                   let val = temp.multiText ? temp.multiText : "";
                   res[col.fieldName] = val;
                 } else if (temp.inputType === "Numeric") {
                   let val = temp.multiText ? temp.multiText : "";
                   res[col.fieldName] = val;
                 } else if (temp.inputType === "Date") {
                   let val = temp.multiText ? new Date(temp.multiText) : "";
                   res[col.fieldName] = val;
                 }
               } else {
                 res[col.fieldName] = "";
               }
             });
           });
         }
         let columnsToShow = [];
         if (dropdownColumn.length > 0) {
           columnsToShow = dropdownColumn.map((item) => (
             <Column
               field={item.fieldName}
               title={item.fieldName}
               width="150px"
              
             />
           ));
         }
         this.setState({ ...this.state, dropdownColumns: columnsToShow });
       } catch (err) {
         console.log(err);
       }
  };
  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }
  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.error(err);
    }
  };

  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,

            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue && originalValue.name != " [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };
  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  createAppState = (dataState) => {
    if (this.state && this.state.validateDataTemp) {
      return {
        validateData: this.state.validateDataTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        validateData: [],
        dataState: dataState,
      };
    }
  };
  onEditCell = () => {};
  validate_rowRender = (row, rowProps) => {
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
    if (rowProps.dataItem.isUncommit === true) {
      backgroundColor = "#301934";
      fontWeight = "bold";
      fontSize = "16px";
    }
    // else if(rowProps.dataItem.isClosedExcelUpdate === true) {
    //   backgroundColor = "#428fed";
    //   fontWeight = "bold";
    //   fontSize = "16px";

    // }

    return React.cloneElement(
      row,
      {
        ...row.props,
        style: {
          ...row.props.style,
          backgroundColor: backgroundColor,
          fontWeight: fontWeight,
          fontSize: fontSize,
        },
      },
      row.props.children
    );
  };
  validate_cellRender = (row, cellProps) => {
    const cellField = cellProps.field;
    var dataItem = cellProps.dataItem;
    const cellValue = dataItem[cellField];
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
    
    if (
      dataItem.updatedColumnsFromExcel &&
      dataItem.updatedColumnsFromExcel.includes(cellField)
    ) {
      backgroundColor = "#034f0e";
      fontWeight = "bold";
      fontSize = "16px";
    } else if (
      dataItem.nonUpdatedColumnsFromExcel &&
      dataItem.nonUpdatedColumnsFromExcel.includes(cellField)
    ) {
      backgroundColor = "#ea8211e3";
      fontWeight = "bold";
      fontSize = "16px";
    }
    
    if (this.checkDate(cellValue)) {
      dataItem[cellField] = cellValue
        ? moment(cellValue).format("DD-MMM-YYYY")
        : "";
    }
    
    return React.cloneElement(
      row,
      {
        ...row.props,
        style: {
          ...row.props.style,
          backgroundColor: backgroundColor,
          fontWeight: fontWeight,
          fontSize: fontSize,
        },
      },
      row.props.children
    );
  };
  checkDate = (dateString) => {
    if (dateString && dateString != "") {
      return moment(dateString, "DD-MMM-YYYY", true).isValid();
    }
    return false;
  };
  render() {
    return (
      <div
        className="tblCont riskRegister dataGrids reportsGrid"
        id="reportaction"
      >
        {this.props.loader || this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <Grid
          data={process(this.state.validateData, this.state.dataState)}
          {...this.state.dataState}
          onDataStateChange={this.dataStateChange}
          rowRender={this.validate_rowRender}
          cellRender={this.validate_cellRender}
          reorderable
          resizable
          sortable={true}
          pageable={true}
          scrollable={true}
        >
          <Column
            field="taskNumber"
            title="Task Number"
            width="200px"
            locked={true}
            cell={ValidateNumberCell}
          />
          <Column field="taskTitle" title="Task Title" width="200px" />
          <Column
            field="taskDescription"
            title="Task Description"
            width="200px"
          />
          <Column
            field="cost"
            title={
              "Cost of Task" + " (" + secureLocalStorage.getItem("currency") + ")"
            }
            width="200px"
          />
          <Column
            field="effort"
            title={"Effort" + " (Days)"}
            filter={"numeric"}
            width="200px"
          />
          <Column
            field="percentageOnTrack"
            title="% on Track"
            width="200px"
            filter={"numeric"}
          />
          <Column
            field="percentageCompletion"
            title="% Completion"
            width="200px"
            filter={"numeric"}
          />
          <Column
            field="priorityRankingName"
            title="Priority Ranking"
            width="200px"
          />
          <Column
            field="progressComment"
            title="Progress Status"
            width="200px"
          />

          {this.state.dropdownColumns}
          <Column
            field="originalCompletionDate"
            title="Original Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="projectedCompletionDate"
            title="Projected Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="actualCompletionDate"
            title="Actual Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="proximityAlertDate"
            title="Proximity Alert Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="delayConsequence"
            title="Delay Consequence"
            width="200px"
          />
          <Column
            field="alertStakeHolders"
            title="Alert Stakeholders"
            width="200px"
          />
          <Column
            field="alertDescription"
            title="Alert Description"
            width="200px"
          />
          <Column field="taskOwnerName" title="Task Owner" width="200px" />
          <Column
            field="createdDate"
            title="Created Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column field="createdByName" title="Created By" width="200px" />
          <Column
            field="updatedDate"
            title="Updated Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column field="updatedByName" title="Updated By" width="200px" />
          <Column
            field="closedDate"
            title="Closed Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column field="isClosed" title="Status" width="200px" />
        </Grid>
      </div>
    );
  }
}
